import Background from "../BackGround/background";
import QrImage from "../../assets/icons/qr_login.svg";
import tickcirclegreen from "../../assets/icons/tick-circle-green.svg";
import { useNavigate } from "react-router";

const Redirection: React.FC = () => {

    const navigate = useNavigate();

    const GotoLogin = () => {
        localStorage.clear();
        sessionStorage.clear();
        navigate("/", { replace: true });
      };


    return (
        <>
            <Background>
            <div className="pt-4 px-3">
              <i onClick={GotoLogin} className="fas fa-arrow-left fas fa-lg" />
              <span  style={{color: "#171D27", marginLeft: "10px", fontSize: "x-large", fontWeight: "600"}}>MPIN is not set</span>
          </div>
                <div className="p-4">
                    <div className="text-center">
                        <img src={QrImage} alt='qrimage' height={148} width={148} />
                    </div>
                    <div className="py-3"  style={{color: "#171D27", fontWeight: "600" , fontSize: "large"}}>
                        Please set MPIN from Rupeezy app
                    </div>
                    <div>
                        <div className="flex items-center mb-2">
                            <img src={tickcirclegreen} alt='bluetick' height={20} width={20} />
                            <span style={{color: "#171D27", marginLeft: "8px"}}>Scan the QR code to download the Rupeezy app</span>
                        </div>
                        <div className="flex items-center mb-2">
                            <img src={tickcirclegreen} alt='bluetick' height={20} width={20} />
                            <span style={{color: "#171D27", marginLeft: "8px"}}>Login using OTP and password</span>
                        </div>
                        <div className="flex items-center mb-2">
                            <img src={tickcirclegreen} alt='bluetick' height={20} width={20} />
                            <span style={{color: "#171D27", marginLeft: "8px"}}>Set MPIN in the app and re-login here</span>
                        </div>
                    </div>
                </div>
            </Background>
        </>
    )
}

export default Redirection;